<script lang="ts" setup>
import { useRouter } from 'vue-router/composables'
import { useUserStore } from '@/stores'

const router = useRouter()
const userStore = useUserStore()

function goToRecharge() {
  router.push({ name: 'pay' })
}
</script>

<template>
  <div class="coin-entry flex items-center cursor-pointer shrink-0" @click="goToRecharge">
    <!-- 半透明胶囊：钻石 + 余额 + 渐变加号 -->
    <div class="coin-pill flex items-center">
      <img
        src="/images/vowpath/home/icon-diamond.png"
        class="coin-gem shrink-0"
        alt=""
      >
      <span class="coin-balance">{{ userStore.coinBalance }}</span>
      <img
        src="/images/vowpath/home/icon-plus.png"
        class="coin-plus shrink-0"
        alt=""
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.coin-pill {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  height: 25px;
  padding: 0 6px;
}

.coin-gem {
  width: 20px;
  height: 18px;
  margin-right: 6px;
}

.coin-balance {
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 16px;
  margin-right: 6px;
}

.coin-plus {
  width: 16px;
  height: 16px;
}
</style>
